import { defineStore } from 'pinia';
import { AuthenticatedUser } from '@/models/AuthenticatedUser';

export type KasutajaState = {
  kasutaja: AuthenticatedUser | null | undefined;
};

export const useKasutajaStore = defineStore('kasutajaStore', {
  state: () => {
    return {
      kasutaja: null,
    } as KasutajaState;
  },
  persist: true,
  getters: {
    onVang(): boolean {
      return this.kasutaja?.isPrisoner === true;
    },
    onKasutusOigus(): boolean {
      return this.kasutaja?.isInUsageRight === true;
    },
    onTingimustegaNous(): boolean {
      return this.kasutaja?.isTermsAccepted === true;
    },
    onHoolduskavaNahtav(): boolean {
      return this.kasutaja?.isMaintenancePlanVisible === true;
    },
    onOigusedJaKohustusedNahtav(): boolean {
      return this.kasutaja?.isRightsAndObligationsVisible === true;
    },
    onYktNahtav(): boolean {
      return this.kasutaja?.isCommunityServiceVisible === true;
    },
    onEvNahtav(): boolean {
      return this.kasutaja?.isElectronicSurveillanceVisible === true;
    }
  },

  actions: {
    satiKasutaja(dto: AuthenticatedUser) {
      this.kasutaja = { ...dto };
    },
    eemaldaKasutaja() {
      this.kasutaja = null;
    }
  },
});
